import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { API } from 'src/app/shared/services/endpoints';
import { ApiHandlerService } from '../../shared/services/api-handler.service';
import { ToasterService } from '../../shared/services/toaster.service';

@Component({
  selector: 'app-investor',
  templateUrl: './investor.component.html',
  styleUrls: ['./investor.component.scss']
})
export class InvestorComponent implements OnInit {

  contactForm: FormGroup;
  public isReadMore: boolean = false;
  public isReadMore1: boolean = false;
  public isReadMore2: boolean = false;
  public isReadMore3: boolean = false;
  public isLoadingApiData: boolean = false
  public isLoadingData: boolean = false;
  public submitted: boolean = false;
  public addedQuery: boolean = false;
  public newsAndEvent: any;
  // @ViewChild(FormGroupDirective) contactFormGroupDirective: FormGroupDirective;'

  constructor(
    public formBuilder: FormBuilder,
    public _service: ApiHandlerService,
    public toaster: ToasterService) { }
  public text = "Assertively Enable Web-Enabled Synergy With Interdependent Processes...";
  ngOnInit(): void {
    let footer = document.getElementsByTagName('footer');
    footer[0].classList.add('without-cars');
    if (footer[1]) {
      footer[1].classList.add('without-cars');
    }
    this.getData();
    this.getNewsAndEvent();
  }


  ngOnDestroy() {
    let footer = document.getElementsByTagName('footer')[0];
    footer.classList.remove('without-cars');
  }

  public pageData: any;

  getData() {
    var apiData = {
      page: 'investor'
    }
    this._service.apiPost(API.CMS_ENDPOINTS.GET_PAGE, apiData).subscribe({
      next: next => {
        console.log(next);
        this.pageData = next.data.page

      },
      error: error => {

      }
    });
  }
  getNewsAndEvent() {
    this.isLoadingApiData = true;
    this._service.apiGet(API.CMS_ENDPOINTS.GET_ALL_BLOG, { isNewsEvent: true }).subscribe({
      next: (result: any) => {
        this.newsAndEvent = result.data.data;
      }, error: err => {
        this.toaster.Error(err.error ? err.error.message : err.message);
        this.isLoadingApiData = false;
      }, complete: () => {
        this.isLoadingApiData = false;
      }
    });
  }


}




